import { render, staticRenderFns } from "./SwitchDevice.vue?vue&type=template&id=39a002ca&"
import script from "./SwitchDevice.vue?vue&type=script&lang=js&"
export * from "./SwitchDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports